var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5895_2440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.66669H9.08329C8.16282 6.66669 7.41663 7.41288 7.41663 8.33335V15C7.41663 15.9205 8.16282 16.6667 9.08329 16.6667H15.75C16.6704 16.6667 17.4166 15.9205 17.4166 15V8.33335C17.4166 7.41288 16.6704 6.66669 15.75 6.66669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 6.66665V4.99998C14.0834 4.55795 13.9078 4.13403 13.5952 3.82147C13.2827 3.50891 12.8587 3.33331 12.4167 3.33331H5.75004C5.30801 3.33331 4.88409 3.50891 4.57153 3.82147C4.25897 4.13403 4.08337 4.55795 4.08337 4.99998V11.6666C4.08337 12.1087 4.25897 12.5326 4.57153 12.8452C4.88409 13.1577 5.30801 13.3333 5.75004 13.3333H7.41671",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5895_2440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.530ffb0cb1d2296e987fc355320df4c0.svg";
export { ForwardRef as ReactComponent };